import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  cursor: pointer;
`;

const CollectionRequirementIcon = ({ width = 26, height = 33, color = '#000' }) => (
  <Wrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 26 33"
      fill={color}
      style={{ display: 'block', margin: 'auto' }}
    >
      <path
        data-name="Path 361"
        d="M.929 33h24.142a.923.923 0 00.929-.917V2.75a.923.923 0 00-.929-.917h-4.8A2.847 2.847 0 0017.571 0H8.435a2.885 2.885 0 00-2.7 1.833H.927a.923.923 0 00-.929.917v29.333A.923.923 0 00.929 33zM7.67 3.366a.9.9 0 01-.237-.709.977.977 0 011-.824h9.136a.977.977 0 01.978.718.913.913 0 01-.189.779.933.933 0 01-.719.337H8.353a.922.922 0 01-.683-.301zm-5.813.3h3.877a2.756 2.756 0 00.561.933 2.812 2.812 0 002.062.9h9.286a2.789 2.789 0 002.155-1.008 2.727 2.727 0 00.47-.825h3.875v27.5H1.857z"
      />
      <path
        data-name="Path 362"
        d="M9.558 8.518L6.5 11.537l-1.2-1.185a.937.937 0 00-1.313 0 .907.907 0 000 1.3l1.857 1.834a.929.929 0 00.656.268.933.933 0 00.657-.268l3.714-3.667a.907.907 0 000-1.3.938.938 0 00-1.313-.001z"
      />
      <path
        data-name="Path 363"
        d="M9.558 15.852L6.5 18.871l-1.2-1.186a.937.937 0 00-1.313 0 .908.908 0 000 1.3l1.857 1.833a.929.929 0 00.656.268.933.933 0 00.657-.268l3.714-3.667a.907.907 0 000-1.3.937.937 0 00-1.313.001z"
      />
      <path
        data-name="Path 364"
        d="M9.558 23.185L6.5 26.2l-1.2-1.185a.937.937 0 00-1.313 0 .907.907 0 000 1.3l1.857 1.833a.93.93 0 00.656.269.934.934 0 00.657-.269l3.714-3.666a.909.909 0 000-1.3.937.937 0 00-1.313.003z"
      />
      <path
        data-name="Path 365"
        d="M21.357 8.25h-7.428a.923.923 0 00-.929.917.923.923 0 00.929.916h7.428a.923.923 0 00.929-.916.923.923 0 00-.929-.917z"
      />
      <path
        data-name="Path 366"
        d="M13.929 13.75h3.714a.922.922 0 00.928-.917.922.922 0 00-.928-.916h-3.714a.923.923 0 00-.929.916.923.923 0 00.929.917z"
      />
      <path
        data-name="Path 367"
        d="M21.357 15.583h-7.428A.923.923 0 0013 16.5a.923.923 0 00.929.917h7.428a.923.923 0 00.929-.917.923.923 0 00-.929-.917z"
      />
      <path
        data-name="Path 368"
        d="M13.929 21.083h3.714a.922.922 0 00.928-.916.922.922 0 00-.928-.917h-3.714a.923.923 0 00-.929.917.923.923 0 00.929.916z"
      />
      <path
        data-name="Path 369"
        d="M21.357 22.917h-7.428a.923.923 0 00-.929.916.923.923 0 00.929.917h7.428a.923.923 0 00.929-.917.923.923 0 00-.929-.916z"
      />
      <path
        data-name="Path 370"
        d="M17.643 26.583h-3.714A.923.923 0 0013 27.5a.923.923 0 00.929.917h3.714a.923.923 0 00.928-.917.923.923 0 00-.928-.917z"
      />
    </svg>
  </Wrapper>
);

export default CollectionRequirementIcon;
